import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'node-noop';
import InsertEmailMacrosDialogWindow from './insert-email-macros-dialog-window';
import InsertAnchorDialogWindow from './insert-anchor-dialog-window';
import InsertLinkToAnchorDialogWindow from './insert-link-to-anchor-dialog-window';
import InsertLinkDialogWindow from './insert-link-dialog-window';
import InsertDocumentDialogWindow from './insert-document-dialog-window';
import InsertSlideShowLinksDialogWindow from './insert-slideshow-links-dialog-window';

import { dialogNames } from './constants';

class EditorWindows extends Component
{
  static propTypes = {
    showLinkStyleOption: PropTypes.bool
  };

  static defaultProps = {
    showLinkStyleOption: false
  };

  constructor(props)
  {
    super(props);
    window.BEditor.openDialog = this.handleOpenWindow;
  }

  state =
  {
    openControlCollection: {},
    callbackSave: noop,
    callbackCancel: noop,
    params: {}
  };

  handleOpenWindow = (dialogName, callbackSave, callbackCancel, params) =>
  {
    this.setState({
      openControlCollection: { [dialogName]: true },
      callbackSave,
      callbackCancel,
      params
    });
  };

  closeDialog = () =>
  {
    this.setState({ openControlCollection: {} });
  };

  handleSave = (params) =>
  {
    const { callbackSave } = this.state;

    this.closeDialog();
    callbackSave(params);
  };

  handleCancel = () =>
  {
    const { callbackCancel } = this.state;

    this.closeDialog();
    callbackCancel();
  };

  render()
  {
    const { showLinkStyleOption } = this.props;

    const {
      openControlCollection,
      params
    } = this.state;

    const windowProps = {
      onSave: this.handleSave,
      onCancel: this.handleCancel,
      params
    };

    return (
      <React.Fragment>
        { openControlCollection[dialogNames.INSERT_ANCHOR_DIALOG] ?
          <InsertAnchorDialogWindow {...windowProps} /> : null }

        { openControlCollection[dialogNames.INSERT_LINK_TO_ANCHOR_DIALOG] ?
          <InsertLinkToAnchorDialogWindow {...windowProps} /> : null }

        { openControlCollection[dialogNames.INSERT_EMAIL_MACROS_DIALOG] ?
          <InsertEmailMacrosDialogWindow {...windowProps} /> : null }

        { openControlCollection[dialogNames.INSERT_DOCUMENT_DIALOG] ?
          <InsertDocumentDialogWindow {...windowProps} /> : null }

        { openControlCollection[dialogNames.INSERT_LINK_DIALOG] ?
          <InsertLinkDialogWindow showLinkStyleOption={showLinkStyleOption} {...windowProps} /> : null }

        { openControlCollection[dialogNames.INSERT_SLIDE_SHOW_LINKS] ?
          <InsertSlideShowLinksDialogWindow {...windowProps} /> : null }
      </React.Fragment>
    );
  }
}

export default EditorWindows;